import React from 'react'
import { Link } from 'react-router-dom'
import { routePath, cityPath } from '../../../utils/urls'

/**
 * Crawlable entry point into the route and city pages.
 *
 * The "Popular Routes" carousel above renders its cards as buttons that
 * prefill the booking form, so the homepage shipped without a single <a> to
 * /routes/* or /cities/* — the programmatic pages had no path in from the
 * strongest page on the site. These are plain links on purpose.
 *
 * Every entry below is a page we prerender (see scripts/seo/tier1.config.mjs);
 * linking to a route whose cities have no CMS content would just point at
 * boilerplate.
 */
const ROUTES = [
  ['delhi', 'agra'],
  ['delhi', 'jaipur'],
  ['delhi', 'chandigarh'],
  ['delhi', 'dehradun'],
  ['delhi', 'shimla'],
  ['delhi', 'lucknow'],
  ['delhi', 'mathura'],
  ['delhi', 'amritsar'],
  ['jaipur', 'delhi'],
  ['jaipur', 'agra'],
  ['jaipur', 'udaipur'],
  ['jaipur', 'jodhpur'],
  ['agra', 'delhi'],
  ['agra', 'jaipur'],
  ['lucknow', 'varanasi'],
  ['lucknow', 'kanpur'],
  ['chandigarh', 'shimla'],
  ['chandigarh', 'amritsar'],
  ['pune', 'nashik'],
  ['pune', 'aurangabad'],
  ['ahmedabad', 'surat'],
  ['ahmedabad', 'vadodara'],
  ['bengaluru', 'mysore'],
  ['bengaluru', 'chennai'],
  ['bengaluru', 'coimbatore'],
  ['chennai', 'tirupati'],
  ['chennai', 'puducherry'],
  ['kochi', 'thiruvananthapuram'],
  ['secunderabad', 'vijayawada'],
  ['kolkata', 'siliguri'],
  ['kolkata', 'puri'],
  ['indore', 'bhopal'],
]

const CITIES = [
  'delhi',
  'gurugram',
  'noida',
  'jaipur',
  'agra',
  'lucknow',
  'varanasi',
  'chandigarh',
  'amritsar',
  'dehradun',
  'shimla',
  'udaipur',
  'jodhpur',
  'ahmedabad',
  'surat',
  'pune',
  'nashik',
  'nagpur',
  'indore',
  'bhopal',
  'bengaluru',
  'mysore',
  'chennai',
  'coimbatore',
  'kochi',
  'secunderabad',
  'visakhapatnam',
  'kolkata',
  'patna',
  'guwahati',
]

const label = (slug) =>
  slug
    .split('-')
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(' ')

const PopularLinks = () => (
  <section className="popular-links">
    <div className="popular-links__group">
      <h2 className="popular-links__heading">More intercity cab routes</h2>
      <ul className="popular-links__list">
        {ROUTES.map(([from, to]) => (
          <li key={`${from}-${to}`}>
            <Link className="popular-links__link" to={routePath(from, to)}>
              {label(from)} to {label(to)} Cab
            </Link>
          </li>
        ))}
      </ul>
    </div>

    <div className="popular-links__group">
      <h2 className="popular-links__heading">Cabs by city</h2>
      <ul className="popular-links__list">
        {CITIES.map((city) => (
          <li key={city}>
            <Link className="popular-links__link" to={cityPath(city)}>
              Cabs in {label(city)}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  </section>
)

export default PopularLinks
